export const PROXY_ACTION_TYPE_AUTH = 'PROXY_ACTION_TYPE_AUTH';
export const PROXY_ACTION_TYPE_MESSAGE_POPUP = 'PROXY_ACTION_TYPE_MESSAGE_POPUP';
export const MODAL_TYPE_CREATE_GROUP = 'MODAL_TYPE_CREATE_GROUP';
export const MODAL_TYPE_LEAVE_GROUP = 'MODAL_TYPE_LEAVE_GROUP';
export const MODAL_TYPE_EDIT_GROUP = 'MODAL_TYPE_EDIT_GROUP';
export const MODAL_TYPE_REPORT_GROUP = 'MODAL_TYPE_REPORT_GROUP';
export const MODAL_TYPE_ARCHIVE_GROUP = 'MODAL_TYPE_ARCHIVE_GROUP';
export const MODAL_TYPE_SHARE_GROUP = 'MODAL_TYPE_SHARE_GROUP';
export const MODAL_TYPE_NOTIFICATIONS_SETTINGS = 'MODAL_TYPE_NOTIFICATIONS_SETTINGS';
export const MODAL_TYPE_ADD_MEMBERS = 'MODAL_TYPE_ADD_MEMBERS';

export const MODAL_LISTENER_NAME = 'platform-root-modal-listener';
